import { setConfig } from "@justhome/common";

setConfig({
  api: {
    core: {
      baseUrl: process.env.NEXT_PUBLIC_CORE_API_HOST,
    },
  },
  logger: {
    service: "budget-calculator",
    version: process.env.NEXT_PUBLIC_RELEASE_VERSION,
  },
});
